// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Qjp2","buttons":"RemoveExpirationActionButtons_buttons__3UOUc"};